import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
const SidebarNavItem = ({ title, type, href, icon: Icon, isCollapsed, isSubmenu }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isActive = location.pathname === href;
    const handleClick = useCallback((event) => {
        event.stopPropagation();
        if (type === 'link') {
            navigate(href);
        }
    }, [navigate, href, type]);
    return (_jsx(Nav.Item, { children: _jsxs(Nav.Link, Object.assign({ onClick: handleClick, className: `${isActive ? 'active' : ''} ${isSubmenu ? 'submenu-item' : ''}` }, { children: [Icon && _jsx(Icon, {}), !isCollapsed && _jsx("span", { children: title })] })) }));
};
export default SidebarNavItem;
